module.exports = __webpack_public_path__ + "static/img/bg-best-picture.3692374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-best-picture.jpg
// module id = 187
// module chunks = 0